export default __webpack_public_path__ + "static/media/No35Closed.7af5cd27.jpg";